import React from 'react';
import RoomSearch from '../components/RoomSearch';

const Home = () => {
    return (
        <div className="home">
            {/* Sticky Search Parameters */}
            <div className="sticky-search-container">
                <RoomSearch />
            </div>
        </div>
    );
};

export default Home;